/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_SavedInputs */

const cs_blog_editor_saved = /** @type {(inputs: Blog_Editor_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uloženo`)
};

const en_blog_editor_saved = /** @type {(inputs: Blog_Editor_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Blog_Editor_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_saved = /** @type {((inputs?: Blog_Editor_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_saved(inputs)
	return cs_blog_editor_saved(inputs)
});